import type { AssistanceServiceProduct } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

// Supported products in ConvoAI: https://bitbucket.org/atlassian/conversational-ai-platform/src/c93fa68285902110cf8a1c6736c42c12da8ae6fc/modules/foundation/utilities/utilities-api/src/main/kotlin/io/atlassian/micros/convoai/foundation/utilities/context/Product.kt#lines-9
export const mapToAssistanceServiceProduct = (product: string): AssistanceServiceProduct => {
	switch (product) {
		case 'CONFLUENCE':
			return 'confluence';
		case 'JSW':
			return 'jira-software';
		case 'JWM':
			return 'jira-core';
		case 'JSM':
			return 'jsm';
		case 'JPD':
			return 'jpd';
		case 'CSM':
			return 'csm';
		case 'ATLAS':
			return 'atlas';
		case 'JIRA_FAMILY':
			return 'jira';
		case 'BITBUCKET':
			return 'bitbucket';
		case 'TRELLO':
			return 'trello';
		case 'ELEVATE':
			return 'elevate';
		case 'RECRUIT':
			return 'recruit';
		case 'MERCURY':
			return 'mercury';
		case 'TOWNSQUARE':
			return 'townsquare';
		case 'ADMINHUB':
			return 'admin-hub';
		case 'GOAL':
			return 'goal';
		case 'PROJECT':
			return 'project';
		default:
			return 'unknown';
	}
};
